import React from "react";
import { Container } from "reactstrap";

const LoadingState = ({ color, message = "Loading unit details..." }) => (
  <div className="page-content">
    <Container fluid>
      <div className="text-center mt-5">
        <div
          className="spinner-grow"
          style={{ color, width: "3rem", height: "3rem" }}
          role="status"
        >
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-3 fs-5">{message}</p>
      </div>
    </Container>
  </div>
);

export default LoadingState;
